import React from 'react';
import { useCollaboration } from '../../contexts/CollaborationContext';
import { Avatar, AvatarFallback, AvatarImage } from '../../mawi-ui';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../mawi-ui';
import { Badge } from '../../mawi-ui';

const UserPresenceIndicator: React.FC = () => {
  const { state } = useCollaboration();

  if (!state.isConnected || state.users.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 px-4 py-2 border-t border-border bg-background">
      <div className="flex -space-x-2">
        {state.users.slice(0, 5).map((user) => (
          <Tooltip key={user.id}>
            <TooltipTrigger asChild>
              <Avatar className="w-8 h-8 border-2 border-background">
                <AvatarImage src={user.avatar} alt={user.name} />
                <AvatarFallback
                  className="text-xs"
                  style={{ backgroundColor: user.color }}
                >
                  {user.name.charAt(0).toUpperCase()}
                </AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipContent>
              <div className="text-center">
                <div className="font-medium">{user.name}</div>
                {user.isTyping && (
                  <div className="text-xs text-muted-foreground">Typing...</div>
                )}
                <div className="text-xs text-muted-foreground">
                  Line {user.cursor.line + 1}, Col {user.cursor.column + 1}
                </div>
              </div>
            </TooltipContent>
          </Tooltip>
        ))}
      </div>

      {state.users.length > 5 && (
        <Badge variant="secondary" className="text-xs">
          +{state.users.length - 5} more
        </Badge>
      )}

      <div className="text-sm text-muted-foreground ml-2">
        {state.users.length} user{state.users.length !== 1 ? 's' : ''} collaborating
      </div>
    </div>
  );
};

export default UserPresenceIndicator;